<ion-list lines="none">

  <ion-item>

    <ion-label>

      <div class="data">
        <yu-icon slot="start" name="calendar"></yu-icon>
        <p>{{ task.dia | date: 'EEEE, dd MMM yyyy' | titlecase }}</p>
      </div>

      @if (task.hora) {

        <div class="data">
          <yu-icon slot="start" name="clock"></yu-icon>

          <p>
            {{ task.hora }} {{ task.hora_fin ? '- ' + task.hora_fin : '' }}
            <sup>{{ task.hora_fin_nexday ? '+1' : '' }} </sup>

            @if (task.local) {
              <span>{{ 'COMMON.IN_PREPOSITION' | translate }}</span> {{ task.local }}
            }
          </p>
        </div>

      } @else if (task.local) {

        <div class="data">
          <yu-icon slot="start" name="map-pin"></yu-icon>
          <p>{{ task.local }}</p>
        </div>

      }

      @if (task.auditores && task.auditores !== '-') {

        <div class="data">
          <yu-icon slot="start" name="user"></yu-icon>
          <p>{{ task.auditores | titlecase }}</p>
        </div>

      }

    </ion-label>

  </ion-item>

</ion-list>


@if (task.descripcion) {

  <ion-list class="detail-block description-block" lines="none">

    <ion-item class="no-lines">
      <ion-label>{{ task.descripcion }}</ion-label>
    </ion-item>

  </ion-list>

}
